import { render, staticRenderFns } from "./TableDetailEfdPurchases.vue?vue&type=template&id=49824839&"
import script from "./TableDetailEfdPurchases.vue?vue&type=script&lang=js&"
export * from "./TableDetailEfdPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports